'use client'

import { useTranslations } from 'next-intl'
import Section from '@/kmsApp/components/layout/section'
import { Field } from '@/kmsApp/components/forms/field'
import Button from '@/kmsApp/components/shared/ui/button'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { CourseForm as CourseFormType } from '@/kmsApp/types/forms/course-form'

import { EMAIL_REGEX, PHONE_REGEX, REQUIRED } from '@/kmsApp/constants/regex-const'

interface Props {
  register: UseFormRegister<CourseFormType>
  errors: FieldErrors<CourseFormType>
  onNext: () => void
  prevStep: () => void
}

export const ClientInformation = ({ register, errors, onNext, prevStep }: Props) => {
  const t = useTranslations('web_course_form')
  const tCommon = useTranslations('common')

  return (
    <div className="">
      <Section titre={t('client_info_title')} icon="person">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Field
            titre={t('last_name')}
            placeholder={t('last_name')}
            {...register('passager.nom', { required: REQUIRED(tCommon).required })}
            error={errors?.passager?.nom?.message}
          />
          <Field
            titre={t('first_name')}
            placeholder={t('first_name')}
            {...register('passager.prenom', { required: REQUIRED(tCommon).required })}
            error={errors?.passager?.prenom?.message}
          />
          <div>
            <Field
              titre={t('email')}
              type="email"
              placeholder={t('email_placeholder')}
              {...register('passager.email', {
                required: REQUIRED(tCommon).required,
                pattern: {
                  value: EMAIL_REGEX,
                  message: t('email_invalid'),
                },
              })}
              error={errors?.passager?.email?.message}
            />
          </div>
          <div>
            <Field
              titre={t('phone')}
              placeholder={t('phone_placeholder')}
              {...register('passager.phone', {
                required: REQUIRED(tCommon).required,
                pattern: {
                  value: PHONE_REGEX,
                  message: t('phone_invalid'),
                },
              })}
              error={errors?.passager?.phone?.message}
            />
          </div>
        </div>
        <div className="mt-8 flex flex-col md:flex-row gap-y-1.5 gap-x-2 justify-end">
          <Button type="button" variant="secondary" onClick={() => prevStep()}>
            {t('back')}
          </Button>
          <Button type="button" className="w-full md:w-auto" onClick={onNext} icon="arrow_forward">
            {t('transport_details')}
          </Button>
        </div>
      </Section>
    </div>
  )
}
